import { useState, useMemo } from 'react';

export const usePagination = ({ items, initialDisplayCount }) => {
  const [showAll, setShowAll] = useState(false);

  const hasMore = items.length > initialDisplayCount;

  const displayedItems = useMemo(
    () => (showAll ? items : items.slice(0, initialDisplayCount)),
    [showAll, items, initialDisplayCount]
  );

  const toggleShowAll = () => setShowAll((prev) => !prev);
  const resetPagination = () => setShowAll(false);

  return { showAll, hasMore, displayedItems, toggleShowAll, resetPagination };
};
